import React from 'react';
import ReactDOM from 'react-dom';
import { Root } from './Root';
import { BrowserRouter } from 'react-router-dom';
import { pca } from './useInitMsal';

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <Root pca={pca} />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);
